// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".avatar-upload-preview[data-v-696910b3] {\n  width: 420px;\n  height: 248px;\n  margin: 50px auto 0;\n  -webkit-box-shadow: 0 0 4px #ccc;\n          box-shadow: 0 0 4px #ccc;\n  overflow: hidden;\n}\n", ""]);
// Exports
module.exports = exports;
